module.exports = __webpack_public_path__ + "static/media/icon_try.f68cc5fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_try.svg
// module id = 716
// module chunks = 0